import React from 'react'

export const Alert = (props:any) => {
  return (
    <div className="fixed z-90 bottom-10 mx-5 md:right-8 delay-300 animate-bounce md:max-w-xl">
      <div className="md:flex md:flex-col p-8 bg-lime-accent-200 shadow-md hover:shodow-lg rounded-2xl">
        <div className="md:flex items-center justify-between">
          <div className="flex items-center">
            <div className="flex flex-col ml-3">
              <div className="font-medium leading-none">
                {props.title}
              </div>
              <p className="text-sm text-gray-900 leading-none mt-1 text-justify">
                {props.text}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
